/**
 * Upsell Cart Drawer — Nudo Imperial
 * assets/upsell-popup.js
 */

(function () {
  'use strict';

  var cfg = Object.assign({
    autoHideMs:       0,
    ctaText:          'Añadir al pedido',
    ctaSuccessText:   '✓ Añadido',
    ctaErrorText:     'Error — inténtalo de nuevo',
    showImage:        true,
    imageSize:        80,
    showPrice:        true,
    showComparePrice: true,
    showProgressBar:  false,
    openCartOnAdd:    true,
    metafieldKey:     'upsell_product',
    position:         'bottom-right',
    cartDrawerWidth:  400,
    marketCountry:    null,
    marketRootUrl:    null,
    moneyFormat:      null,
    claimText:        'Completa el look con\u2026'
  }, window.__upsellConfig || {});

  // ── Helpers ──────────────────────────────────────────────────────────
  function root() {
    if (cfg.marketRootUrl) {
      return cfg.marketRootUrl.replace(/\/+$/, '');
    }
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/+$/, '');
  }

  function formatMoney(cents) {
    var format = cfg.moneyFormat || (window.Shopify && window.Shopify.money_format) || '{{amount}}';
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    // Fallback manual
    var amount = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  // ── Interceptar fetch — debe declararse antes de cualquier uso ────────
  var originalFetch = window.fetch;
  window.fetch = async function(input, init) {
    init = init || {};
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = url.indexOf('/cart/add') !== -1;
    var response  = await originalFetch.apply(this, arguments);

    if (isCartAdd) {
      response.clone().json().then(async function(cartData) {
        // /cart/add.js devuelve objeto con `items` (múltiples) o item directo (uno solo)
        var item = cartData.items ? cartData.items[0] : cartData;
        if (!item || !item.handle) return;

        var upsellHandle = await fetchUpsellHandle(item.handle);
        if (!upsellHandle) return;

        var cartItems = await getCartItems();
        var alreadyIn = cartItems.some(function(ci) {
          return ci.handle === upsellHandle || ci.product_handle === upsellHandle;
        });
        if (alreadyIn) return;

        var upsellProduct = await fetchProductData(upsellHandle);
        if (!upsellProduct || !upsellProduct.available) return;

        setTimeout(function() {
          injectUpsell(upsellProduct);
        }, 600);

      }).catch(function() {});
    }

    return response;
  };

  // ── Data fetching ─────────────────────────────────────────────────────
  async function getCartItems() {
    try {
      var r = await originalFetch(root() + '/cart.js');
      var d = await r.json();
      return d.items || [];
    } catch (e) { return []; }
  }

  async function fetchProductData(handle) {
    try {
      var country = cfg.marketCountry ? '?country=' + cfg.marketCountry : '';
      var r = await originalFetch(root() + '/products/' + handle + '.js' + country);
      if (!r.ok) return null;
      return await r.json();
    } catch (e) { return null; }
  }

  async function fetchUpsellHandle(productHandle) {
    var map = window.__upsellMap || {};
    return map[productHandle] || null;
  }

  // ── Encontrar contenedor de inyección ────────────────────────────────
  function findInjectTarget() {
    var summary = document.querySelector('.cart-drawer__summary');
    if (summary) return summary.parentElement;
    return document.querySelector('.cart-drawer__inner') || null;
  }

  function findInsertBefore() {
    return document.querySelector('.cart-drawer__summary') || null;
  }

  // ── Construir el bloque de upsell ────────────────────────────────────
  function buildUpsellBlock(product, variant) {
    var block = document.createElement('div');
    block.id = 'upsell-drawer-block';
    block.className = 'upsell-drawer';

    var imageHtml = '';
    if (cfg.showImage && product.featured_image) {
      var size = cfg.imageSize * 2;
      var src = product.featured_image.replace(/(\.[^.?]+)(\?|$)/, '_' + size + 'x' + size + '$1$2');
      imageHtml = '<a href="/products/' + product.handle + '" class="upsell-drawer__img-link" tabindex="-1">'
        + '<img src="' + src + '" alt="' + product.title.replace(/"/g, '&quot;') + '" '
        + 'width="' + cfg.imageSize + '" height="' + cfg.imageSize + '" loading="lazy" class="upsell-drawer__img">'
        + '</a>';
    }

    var compareHtml = '';
    if (cfg.showComparePrice && variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareHtml = '<span class="upsell-drawer__compare">' + formatMoney(variant.compare_at_price) + '</span>';
    }

    var priceHtml = cfg.showPrice
      ? '<div class="upsell-drawer__pricing"><span class="upsell-drawer__price">'
          + formatMoney(variant.price) + '</span>' + compareHtml + '</div>'
      : '';

    var variantHtml = '';
    if (product.variants.length > 1) {
      var opts = product.variants.map(function(v) {
        return '<option value="' + v.id + '"' + (!v.available ? ' disabled' : '') + '>' + v.title + '</option>';
      }).join('');
      variantHtml = '<select id="upsell-drawer-variant" class="upsell-drawer__variant-select" aria-label="Selecciona una opción">'
        + opts + '</select>';
    }

    block.innerHTML =
      '<div class="upsell-drawer__inner">'
      + '<p class="upsell-drawer__claim">' + (cfg.claimText || 'Completa el look con\u2026') + '</p>'
      + '<div class="upsell-drawer__product">'
      + imageHtml
      + '<div class="upsell-drawer__info">'
      + '<a href="/products/' + product.handle + '" class="upsell-drawer__title">' + product.title + '</a>'
      + priceHtml
      + variantHtml
      + '<button id="upsell-drawer-cta" class="upsell-drawer__cta" type="button" data-variant-id="' + variant.id + '">'
      + '<span class="upsell-drawer__cta-text">' + cfg.ctaText + '</span>'
      + '<span class="upsell-drawer__cta-spinner" hidden aria-hidden="true">'
      + '<svg width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="7.5" cy="7.5" r="5.5" stroke="currentColor" stroke-width="1.5" stroke-dasharray="22 12" stroke-linecap="round"/></svg>'
      + '</span>'
      + '</button>'
      + '</div>'
      + '</div>'
      + '</div>';

    return block;
  }

  // ── Inyectar en el drawer ────────────────────────────────────────────
  function injectUpsell(product) {
    removeUpsellBlock();

    var target = findInjectTarget();
    if (!target) return;

    var variant = product.variants[0];
    var block = buildUpsellBlock(product, variant);

    var insertBefore = findInsertBefore();
    if (insertBefore && insertBefore.parentElement === target) {
      target.insertBefore(block, insertBefore);
    } else {
      var cartItems = target.querySelector('cart-items-component');
      if (cartItems && cartItems.nextSibling) {
        target.insertBefore(block, cartItems.nextSibling);
      } else {
        target.appendChild(block);
      }
    }

    bindUpsellEvents(block, product);
  }

  function removeUpsellBlock() {
    var existing = document.getElementById('upsell-drawer-block');
    if (existing) existing.remove();
  }

  // ── Eventos del bloque ───────────────────────────────────────────────
  function bindUpsellEvents(block, product) {
    var sel = block.querySelector('#upsell-drawer-variant');
    var cta = block.querySelector('#upsell-drawer-cta');

    if (sel && cta) {
      sel.addEventListener('change', function() {
        cta.dataset.variantId = sel.value;
        var selected = product.variants.find(function(v) { return String(v.id) === sel.value; });
        if (selected) {
          var pEl = block.querySelector('.upsell-drawer__price');
          if (pEl) pEl.textContent = formatMoney(selected.price);
          var cEl = block.querySelector('.upsell-drawer__compare');
          if (cEl) {
            if (selected.compare_at_price && selected.compare_at_price > selected.price) {
              cEl.textContent = formatMoney(selected.compare_at_price);
              cEl.removeAttribute('hidden');
            } else {
              cEl.setAttribute('hidden', '');
            }
          }
        }
      });
    }

    if (cta) {
      cta.addEventListener('click', function() {
        addToCart(cta, product);
      });
    }
  }

  // ── Add to cart ──────────────────────────────────────────────────────
  async function addToCart(cta, product) {
    var variantId = cta.dataset.variantId;
    if (!variantId) return;

    var textEl    = cta.querySelector('.upsell-drawer__cta-text');
    var spinnerEl = cta.querySelector('.upsell-drawer__cta-spinner');

    cta.disabled = true;
    if (textEl)    textEl.setAttribute('hidden', '');
    if (spinnerEl) spinnerEl.removeAttribute('hidden');

    try {
      var cartItemsSections = Array.from(
        document.querySelectorAll('cart-items-component[data-section-id]')
      ).map(function(el) { return el.dataset.sectionId; }).filter(Boolean);

      var body = {
        id: parseInt(variantId, 10),
        quantity: 1
      };
      if (cartItemsSections.length > 0) {
        body.sections = cartItemsSections.join(',');
        body.sections_url = window.location.pathname;
      }

      var r = await originalFetch(root() + '/cart/add.js', {
        method:      'POST',
        headers:     { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:        JSON.stringify(body),
        credentials: 'same-origin'
      });

      if (!r.ok) throw new Error('failed');
      var response = await r.json();

      if (spinnerEl) spinnerEl.setAttribute('hidden', '');
      if (textEl)    { textEl.removeAttribute('hidden'); textEl.textContent = cfg.ctaSuccessText; }
      cta.classList.add('is-added');

      // Disparar evento exactamente como lo hace el tema nativo
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: response,
          sourceId: 'upsell-drawer',
          data: {
            source: 'product-form-component',
            itemCount: 1,
            sections: response.sections || null
          }
        }
      }));

      // Tracking Meta Pixel
      if (window.fbq) {
        fbq('track', 'AddToCart', {
          content_ids:  [variantId],
          content_type: 'product',
          value:        (variant && variant.price ? variant.price / 100 : 0),
          currency:     (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
          content_name: product.title,
          source:       'upsell_drawer'
        });
      }

      // Ocultar el bloque con animación
      setTimeout(function() {
        var block = document.getElementById('upsell-drawer-block');
        if (block) {
          block.classList.add('upsell-drawer--added');
          setTimeout(function() { block.remove(); }, 500);
        }
      }, 300);

    } catch (e) {
      if (spinnerEl) spinnerEl.setAttribute('hidden', '');
      if (textEl)    { textEl.removeAttribute('hidden'); textEl.textContent = cfg.ctaErrorText; }
      cta.disabled = false;
      setTimeout(function() {
        cta.disabled = false;
        if (textEl) textEl.textContent = cfg.ctaText;
        cta.classList.remove('is-added');
      }, 2500);
    }
  }

  // ── Limpiar el bloque si el drawer se cierra ─────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
      var closeBtn = e.target.closest('[data-action="close"], .cart-drawer__close, [aria-label*="cerrar" i], [aria-label*="close" i]');
      if (closeBtn) {
        setTimeout(removeUpsellBlock, 400);
      }
    });
  });

})();